import type { AxiosPromise } from 'axios'
import request from '@core/request'

/** 从发布管理「添加追踪」跳转时，暂存待填入的文章链接（sessionStorage key） */
export const AI_TRACK_PREFILL_KEY = 'AI_TRACK_PREFILL_URLS'

/**
 * 根据链接集合查询发布情况（新建AI引用追踪）
 * @param data urls - 链接集合
 */
export function queryPublishByUrls(data: { urls: string[] }): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/queryPublishByUrls',
    data,
  })
}

/** 媒体平台 */
export interface MediaPlatform {
  id: number
  platformName: string
  linkExample: string
  logo: string
  isOut: number
}

/**
 * 获取支持的媒体平台列表（未删除）
 */
export function mediaPlatformListAll(): AxiosPromise {
  return request({
    method: 'post',
    url: '/mediaPlatform/listAll',
  })
}

/**
 * AI引用追踪记录列表
 * @param data pageNum, pageSize, platform?, url?
 */
export function aiCitationRecordList(data: {
  pageNum: number
  pageSize: number
  platform?: string
  url?: string
}): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/aiCitationRecordList',
    data,
  })
}

/**
 * AI引用追踪记录删除
 * @param data ids - 记录ID集合
 */
export function aiCitationRecordDelete(data: { ids: number[] }): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/aiCitationRecordDelete',
    data,
  })
}

/**
 * AI引用追踪详情（根据记录ID查询引用追踪结果）
 * @param id - 记录ID
 */
export function getCitationDetail(id: string | number): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/citation',
    params: { id },
  })
}
